export default __webpack_public_path__ + "a5c8f290d14009158895898f217478c1.png";